import { MemberDetailsDto } from '../listtones/memberdetailsdto';

export interface BlacklistDto
{
    getServiceName():string;
    getMsisdnB():string;
    getBlacklistId():string;
    getBlacklistName():string;
    getBlacklistDesc():string;
    getIsBlocked():string;
    getDeletedMembersList(): string[];
    getMembersList(): MemberDetailsDto[];
    getId(): string;
}

export class BlacklistDtoImpl implements BlacklistDto
{
   
    private serviceName: string;
    private msisdnB: string;
    private groupId: string;
    private groupName: string;
    private groupDesc: string;
    private isBlocked: string;
    private deletedMembersList: string[] = [];
    private membersList: MemberDetailsDto[];
    private id: string;

    getDeletedMembersList(): string[] {
       return this.deletedMembersList;
    }

    setDeletedMembersList(membersList: string[])
    {
        this.deletedMembersList = membersList;
    }

    setServiceName(serviceName: string)
    {
        this.serviceName = serviceName;
    }
    getServiceName(): string 
    {
        return this.serviceName;
    }

    setMsisdnB(msisdnB: string)
    {
        this.msisdnB = msisdnB;
    }
    getMsisdnB(): string 
    {
        return this.msisdnB;
    }

    setBlacklistId(groupId: string)
    {
        this.groupId = groupId;
    }
    getBlacklistId(): string 
    {
        return this.groupId;
    }

    setBlacklistName(groupName: string)
    {
        this.groupName = groupName;
    }
    getBlacklistName(): string 
    {
        return this.groupName;
    }

    
    setBlacklistDesc(groupDesc: string)
    {
        this.groupDesc = groupDesc;
    }
    getBlacklistDesc(): string 
    {
        return this.groupDesc;
    }
    
    setIsBlocked(isBlocked: string)
    {
        this.isBlocked = isBlocked;
    }
    getIsBlocked(): string 
    {
        return this.isBlocked;
    }

    setMembersList(membersList: MemberDetailsDto[])
    {
        this.membersList = membersList;
    }
    getMembersList(): MemberDetailsDto[] 
    {
        return this.membersList;
    }
 
    setId(id: string)
    {
        this.id = id;
    }
    getId(): string 
    {
        return this.id;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/blacklist/blacklistdto.tsx